import React, { useEffect } from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  Modal,
  TableAdv,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { mapTableRows } from "../../../../../../../utils";

const ViewI94 = ({ isOpen, onClose,data  }) => {
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        i94Number: "",
        dateOfLastArrival: "",
        statusExpiryDate: "",
        status: "",
        priorityDate: "",
      },
      {
        passportNumber: { type: "text", required: true },
      }
    );

  const tableData = [];
  const columns = [
    {
      key: "title",
      label: "Title",
    },
    {
      key: "comments",
      label: "Comments",
    },

    {
      key: "attachment",
      label: "Attachment",
      render: (row) => (
        <div className="text-info cursor-pointer">
          <Button
            title={row.attachment}
            variant="text"
            color="info"
            icon={"download"}
            size="xs"
            iconPosition="after"
          />
        </div>
      ),
    },

    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  useEffect(() => {
    if (data) {
      setFormData(data);
    }
  }, [data]);
  return (
    <Modal
      title={"VIEW I-94 DETAILS"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-7xl"
    >
      <div>
        <div className="grid grid-cols-2 xl:grid-cols-3 mt-4 gap-x-6 gap-y-4 ">
          <FormFieldSet
            type="text"
            title={"I-94 Number"}
            placeholder="Enter I-94 Number"
            value={formData.i94Number}
            onChange={(value) => handleChange("i94Number", value)}
            error={errors.i94Number}
          />
          <FormFieldSet
            type="datepicker"
            title={"Date of Last Arrival"}
            placeholder="Select Date of Last Arrival"
            value={formData.dateOfLastArrival}
            onChange={(value) => handleChange("dateOfLastArrival", value)}
            error={errors.dateOfLastArrival}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Status Expiry Date"}
            placeholder="Select Status Expiry Date"
            value={formData.statusExpiryDate}
            onChange={(value) => handleChange("statusExpiryDate", value)}
            error={errors.statusExpiryDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title={"Status"}
            placeholder="Select Status"
            value={formData.status}
            onChange={(value) => handleChange("status", value)}
            error={errors.status}
          />
          <FormFieldSet
            type="datepicker"
            title={"Priority Date"}
            placeholder="Select Priority Date"
            value={formData.priorityDate}
            onChange={(value) => handleChange("priorityDate", value)}
            error={errors.priorityDate}
            showDropdown={false}
          />
        </div>
        <div className="mt-6 ">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ATTACHMENTS"} tag="p" />
              </div>
            }
          />
          <Divider />
        </div>

        <div className="mt-4">
          <TableAdv tableId={`immigration_h1b_h1bview_passporti94_i94detail_viewi94`} rows={mappedRows} columns={columns} hideToolBar />
        </div>

        <div className="flex gap-3 justify-end my-8">
          <Button title="Close" variant="outlined" onClick={onClose} />
        </div>
      </div>
    </Modal>
  );
};

export default ViewI94;
